import { render, staticRenderFns } from "./productItemForm.vue?vue&type=template&id=328e3fb8&"
import script from "./productItemForm.vue?vue&type=script&lang=js&"
export * from "./productItemForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports